import React, { useState, useEffect } from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import * as virActions from "src/actions/virActions";
import { ATHENA_VIR_PREPARE_BE, ATHENA_VIR_PREPARE_THERMEON } from "src/types/actions";
import { useForm, Controller } from "react-hook-form";
import * as appActions from "src/actions/appActions";
import { useIsMount } from "src/hooks/useIsMount";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import { RoundedButton } from "@packages/ui";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import brandColors from "@packages/ui/theme/colors";


const DigitalVIRVehicleConditionAndPolice = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedVirid = useSelector((state) => state.vir?.athenaSelectedId?.selectedId);
  const athenaVirDetail = useSelector((state) => state.vir.athenaVirDetail);
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);

  const athenaVirDetailPatch = useSelector((state) => state.vir.athenaVirDetailPatch);
  const resubmitFlag = useSelector((state) => state.vir?.athenaVirResubmit?.flag);
  const athenaRole = useSelector((state) => state.vir?.athenaRole?.role);
  const disableEdit = resubmitFlag && athenaRole !== "staff";
  const previousData = resubmitFlag
    ? athenaVirDetail?.data?.VehicleConditionAndPoliceDetails
    : athenaVirDetailPatch?.data?.VehicleConditionAndPoliceDetails;

  const isMount = useIsMount();
  const brand = getBrandFromUrl().toLowerCase();

  const {
    register,
    control,
    setValue,
    handleSubmit,
    watch,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: {
      question1: previousData?.VehicleDrivable === "N" ? "no" : "yes",
      question2: previousData?.VehicleTowed === "Y" ? "yes" : "no",
      towCompany: previousData?.TowCompany || "",
      question3: previousData?.PoliceAttended === "Y" ? "yes" : "no",
      policeReportNumber: previousData?.Police?.PoliceReportNumber || "",
      policeOfficer: previousData?.Police?.PoliceName || "",
      policeStation: previousData?.Police?.PoliceStation || "",
      question4: previousData?.HasInsurance === "Y" ? "yes" : "no",
      insuranceNumber: previousData?.Insurance?.InsuranceNumber || "",
      insuranceProvider: previousData?.Insurance?.InsuranceProvider || "",
    },
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!isMount) {
      if (!athenaVirDetailPatch.loading && loading) {
        setLoading(false);
        if (athenaVirDetailPatch.error) {
          dispatch(
            appActions.createToast({
              type: "error",
              message: "Failed to update",
            })
          );
        } else {
          dispatch(
            appActions.createToast({
              type: "success",
              message: "Vehicle Incident Report is updated",
            })
          );
          dispatch(
            virActions.detailVir({
              virId: selectedVirid,
            })
          );
          navigate(`/vehicleincidents/incidentdetails?brand=${brand}`);
        }
      }
    }
  }, [athenaVirDetailPatch.loading]);

  const onSubmit = (inputs) => {
    setLoading(true);

    if (!inputs.question1 || !inputs.question2 || !inputs.question3 || !inputs.question4) {
      setLoading(false);
      dispatch(
        appActions.createToast({
          type: "error",
          message: "You need to answer all the questions",
        })
      );
      return;
    }

    const virPayloadBE = {
      VehicleDrivable: inputs.question1 === "yes" ? "Y" : "N",
      VehicleTowed: inputs.question2 === "yes" ? "Y" : "N",
      PoliceAttended: inputs.question3 === "yes" ? "Y" : "N",
      HasInsurance: inputs.question4 === "yes" ? "Y" : "N",
    };

    const virPayloadTHERMEON = {
      TowCompany: inputs.towCompany,
      PoliceReportNumber: inputs.policeReportNumber,
      PoliceName: inputs.policeOfficer,
      PoliceStation: inputs.policeStation,
    };

    const params = {
      virId: selectedVirid,
      virStatus: resubmitFlag ? "SubmissionPage" : "VehicleConditionAndPolice",
      data: {
        VehicleConditionAndPoliceDetails: {
          VehicleDrivable: inputs.question1 === "yes" ? "Y" : "N",
          VehicleTowed: inputs.question2 === "yes" ? "Y" : "N",
          TowCompany: inputs.towCompany,
          PoliceAttended: inputs.question3 === "yes" ? "Y" : "N",
          Police: {
            PoliceReportNumber: inputs.policeReportNumber,
            PoliceName: inputs.policeOfficer,
            PoliceStation: inputs.policeStation,
          },
          HasInsurance: inputs.question4 === "yes" ? "Y" : "N",
          Insurance: {
            InsuranceNumber: inputs.insuranceNumber,
            InsuranceProvider: inputs.insuranceProvider,
          },
        },
      },
    };

    if (athenaSource === "sms" && isDirty) {
      params.data.CustomerEditBySms = true;
    }

    dispatch({ type: ATHENA_VIR_PREPARE_BE, payload: virPayloadBE });
    dispatch({ type: ATHENA_VIR_PREPARE_THERMEON, payload: virPayloadTHERMEON });
    dispatch(virActions.detailPatchVir(params));
    // todo
  };

  return (
    <>
      <h2 className={classes.heading}>Please provide vehicle condition and Police details.</h2>

      <br />
      <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] }} />
      <Box
        sx={{
          p: 4,
          textAlign: "left",
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth component="fieldset">
            <FormLabel component="legend" className={classes.radioFormat}>
              Is the vehicle driveable?
            </FormLabel>
            <Controller
              name="question1"
              control={control}
              render={({ field }) => (
                <RadioGroup row {...field}>
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                    disabled={disableEdit && previousData?.VehicleDrivable === "Y"}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="No"
                    disabled={disableEdit && previousData?.VehicleDrivable === "Y"}
                  />
                </RadioGroup>
              )}
            />
          </FormControl>

          <FormControl fullWidth component="fieldset">
            <FormLabel component="legend" className={classes.radioFormat}>
              Has the vehicle been towed?
            </FormLabel>
            <Controller
              name="question2"
              control={control}
              render={({ field }) => (
                <RadioGroup row {...field}>
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                    disabled={disableEdit && previousData?.VehicleTowed === "Y"}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="No"
                    disabled={disableEdit && previousData?.VehicleTowed === "Y"}
                  />
                </RadioGroup>
              )}
            />
            {(watch("question2") === "yes" || previousData?.TowCompany) && (
              <TextField
                label="Tow company / service name"
                variant="outlined"
                fullWidth
                margin="normal"
                {...register("towCompany", { required: "Towcompany is required" })}
                error={!!errors.towCompany}
                helperText={errors.towCompany?.message}
                disabled={
                  disableEdit &&
                  previousData?.TowCompany !== "" &&
                  previousData?.TowCompany !== undefined
                }
              />
            )}
          </FormControl>

          <FormControl fullWidth component="fieldset">
            <FormLabel component="legend" className={classes.radioFormat}>
              Were Police in attendance?
            </FormLabel>
            <Controller
              name="question3"
              control={control}
              render={({ field }) => (
                <RadioGroup row {...field}>
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                    disabled={disableEdit && previousData?.PoliceAttended === "Y"}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="No"
                    disabled={disableEdit && previousData?.PoliceAttended === "Y"}
                  />
                </RadioGroup>
              )}
            />
            {watch("question3") === "yes" && (
              <>
                <TextField
                  label="Police Report #"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="text" // Change from "number" to "text"
                  inputMode="numeric" // Ensures only numbers are entered on mobile
                  {...register("policeReportNumber", {
                    required: "Police report number is required",
                    pattern: {
                      value: /^[a-zA-Z0-9- ]+$/,
                      message: "both letters and numbers are allowed",
                    },
                  })}
                  error={!!errors.policeReportNumber}
                  helperText={errors.policeReportNumber?.message}
                  disabled={
                    disableEdit &&
                    previousData?.Police?.PoliceReportNumber !== "" &&
                    previousData?.Police?.PoliceReportNumber !== undefined
                  }
                />
                <TextField
                  label="Police Officer Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  {...register("policeOfficer", {
                    required: "Police Office name is required",
                  })}
                  error={!!errors.policeOfficer}
                  helperText={errors.policeOfficer?.message}
                  disabled={
                    disableEdit &&
                    previousData?.Police?.PoliceName !== "" &&
                    previousData?.Police?.PoliceName !== undefined
                  }
                />
                <TextField
                  label="Police Station Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  {...register("policeStation", { required: "Police station is required" })}
                  error={!!errors.policeStation}
                  helperText={errors.policeStation?.message}
                  disabled={
                    disableEdit &&
                    previousData?.Police?.PoliceStation !== "" &&
                    previousData?.Police?.PoliceStation !== undefined
                  }
                />
              </>
            )}
          </FormControl>
          <FormControl fullWidth component="fieldset">
            <FormLabel component="legend" className={classes.radioFormat}>
              Do you have insurance for this incident?
            </FormLabel>
            <Controller
              name="question4"
              control={control}
              render={({ field }) => (
                <RadioGroup row {...field}>
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                    disabled={disableEdit && previousData?.HasInsurance === "Y"}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="No"
                    disabled={disableEdit && previousData?.HasInsurance === "Y"}
                  />
                </RadioGroup>
              )}
            />
            {watch("question4") === "yes" && (
              <>
                <TextField
                  label="Insurance / Claim No."
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  {...register("insuranceNumber")}
                  error={!!errors.insuranceNumber}
                  helperText={errors.insuranceNumber?.message}
                  disabled={
                    disableEdit &&
                    previousData?.Insurance?.InsuranceNumber !== "" &&
                    previousData?.Insurance?.InsuranceNumber !== undefined
                  }
                />
                <TextField
                  label="Insurance Provider"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  {...register("insuranceProvider")}
                  error={!!errors.insuranceProvider}
                  helperText={errors.insuranceProvider?.message}
                  disabled={
                    disableEdit &&
                    previousData?.Insurance?.InsuranceProvider !== "" &&
                    previousData?.Insurance?.InsuranceProvider !== undefined
                  }
                />
              </>
            )}
          </FormControl>

          <Box sx={{ my: 3 }}>
            <div>
              <RoundedButton
                variant="contained"
                fullWidth
                size="large"
                sx={{ mt: 2, width: "80%", margin: "2" }}
                type="submit"
                disabled={loading} // Disable the button while loading
              >
                {loading ? <CircularProgress /> : "Continue"}
              </RoundedButton>
            </div>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default DigitalVIRVehicleConditionAndPolice;
